import type { Ref, RefCallback } from 'react'

export function mergeRefs<T>(...refs: Array<Ref<T> | undefined>): RefCallback<T> {
  return (node) =>
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(node)
      } else if (ref) {
        ;(ref as { current: T | null }).current = node
      }
    })
}
